<template>
<div class="model-wraper" :class="{'cate-visible': showCate}">
  <categories
    class="categories"
    v-if="showCate"
    :current="currentCategory"
    @onCategoryChanged="handeCategory"
    :list="categories"></categories>
  <div class="m-content">
    <scroll class="brands-wapper" ref="bscroll" :options="leftScrollOPtions" :data="brands" scroll-mode :scrollRefresh="scrollRefresh">
      <brands class="brands" :show-img="showLogo" :current="currentBrand" @onBrandChanged="onBrandChanged" :list="brands"></brands>
    </scroll>
    <scroll class="products" :options="{
      click: true,
      pullUpLoad: {
        threshold: 50
      },
      scrollbar: true
    }" :data="products" ref="productsWrap" @pullingUp="infiniteHandler" v-loading="loading" scroll-mode :scrollRefresh="scrollRefresh">
      <div>
        <!-- 2020-07-29新增广告位 -->
        <slot name="ad-content"></slot>
        <products  @onProductChanged="onProductChanged" :list="products" :product-img="productImg"></products>
      </div>
      <!-- <no-ssr> -->
        <!-- <infinite-loading @infinite="infiniteHandler" ref="infinite" v-if="products.length && infiniteLoad"> -->
          <span slot="no-more">
            {{ $t('withoutMore') }}
          </span>
          <span slot="no-results">
            {{ $t('withoutMore') }}
          </span>
        <!-- </infinite-loading> -->
      <!-- </no-ssr> -->
    </scroll>
  </div>
</div>
</template>

<style type="text/css" src="./model.css" scoped></style>

<script type="text/javascript">
import Brands from '../brands/brands';
import Categories from '../categories/categories';
import Products from '../product-list/product-list';
// import BScroll from 'better-scroll';
import { Loading } from 'element-ui';
import VueScrollTo from 'vue-scrollto';
// import InfiniteLoading from 'vue-infinite-loading';
import Vue from 'vue';
import Scroll from './scroll';

Loading.directive.install(Vue);

export default {
  components: {
    Brands,
    Categories,
    Products,
    // InfiniteLoading,
    Scroll
  },
  props: {
    currentBrand: String,
    currentCategory: String,
    categories: Array,
    brands: Array,
    products: Array,
    loading: Boolean,
    infiniteLoad: {
      type: Boolean,
      default: true
    },
    showCate: {
      type: Boolean,
      default: true
    },
    scrollRefresh: {
      type: Boolean,
      default: false
    },
    productImg: Boolean,
    showLogo: Boolean,
    leftScrollOPtions: {
      type: Object,
      default: function () {
        return { click: true };
      }
    }
  },
  watch: {
    // 切换的时候，scroll 重置.
    loading () {
      this.reset();
    }
  },

  methods: {
    reset () {
      VueScrollTo.scrollTo(this.$refs.productsWrap.$el, 200, {
        container: this.$refs.productsWrap.$el,
        onDone: () => {
        }
      });

      if (this.$refs.productsWrap.scroll) {
        this.$refs.productsWrap.scroll.scrollTo(0, 0);
        this.$refs.productsWrap.reset();
      }
    },
    handeCategory (data) {
      this.reset();
      this.$emit('categoryClick', data);
    },
    onBrandChanged (data) {
      this.reset();
      this.$emit('brandClick', data);
    },
    onProductChanged (data) {
      this.$emit('productClick', data);
    },
    infiniteHandler ($sta) {
      this.$emit('infinite', $sta);
    },
    init () {
      this.$refs.bscroll.scroll.scrollToElement(this.$refs.bscroll.$el.querySelector('.is-active'), 200, 0, true);
    }
  },

  mounted () {
    this.init();
  }
};
</script>



// WEBPACK FOOTER //
// src/core/models/model.vue